<template>
    <v-dialog
        v-model="localDialog"
        width="35%"
        @update:modelValue="updateDialog"
        transition=""
        persistent
        :open-delay="0"
        :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Asset Location" : "Update Asset Location" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="AssetLocationSetup">
                    <v-row>
                        <v-col  cols="12">
                            <v-text-field
                            density="compact" 
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="name.value.value"
                            :error-messages="name.errorMessage.value"
                            clearable
                            >
                                <template #label>
                                Name <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>
                            
                            <v-textarea
                            label="Remarks (Optional)"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            clearable
                            auto-grow
                            rows="1"
                            ></v-textarea>

                        </v-col>
                        
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-checkbox
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            color="primary"
                            :true-value="1"
                            :false-value="0"
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >Close</v-btn>
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";

export default {
    name: "Asset Locations",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                asset_location_id: "",
                name: "",
                remarks: "",
                status: 1,
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            errorMessages: "",
            preview: "/src/assets/no_preview.jpeg",
            loading: false,
            isEntryMode: true,
            depreciation_loading: false,
        };
    },
    computed: {},
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                console.log(newData)
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.asset_location_id.setValue(newData.id || '', false);
                this.name.setValue(newData.name || "", false);
                this.remarks.setValue(newData.remarks || "", false);
                this.status.setValue(newData.status, false);
            }
        },
    },
    created() {},
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                name: yup.string().required().min(1).max(50).trim().label("Name"),
                remarks: yup.string().max(250).nullable().trim().label("Remarks"),
            }),
        });

        const asset_location_id = useField("asset_location_id");
        const name = useField("name");
        const remarks = useField("remarks");
        const status = useField("status");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            console.log(values)
        store
            .dispatch("saveUpdateAssetLocation", values)
            .then((response) => {
                resetForm();
                emit("update:dialog", false);
                toast.success(response.data.message);
                loading.value = true;
                store
                    .dispatch("getAssetLocationsList")
                    .then((data) => {
                        loading.value = false;
                    })
                    .catch((error) => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    });
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            asset_location_id,
            name,
            remarks,
            status,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {},
    
}

</script>
